import React from 'react';

import { colors } from '../../styles/colors';
import { rem } from '../../styles/rem';
import { FontFamily, FontWeight } from '../../styles/typography';

function HeaderBrand({ className }: { className?: string }) {
  return (
    <span
      className={className}
      sx={{
        display: 'block',
        fontFamily: FontFamily.Heading,
        fontSize: [rem(18), rem(24)],
        fontWeight: FontWeight.Medium,
        lineHeight: 1.25,
        whiteSpace: 'nowrap',
        color: colors.base.Text.Brand,
      }}
    >
      Vælgererklæring
    </span>
  );
}

export default HeaderBrand;
